import { Box, ResponsiveContext } from "grommet";
import { useContext } from "react";
import CenteredColumn from "../components/CenteredColumn";
import PageHeader from "../components/PageHeader";
import AppContext from "../stateManager/appContext";
import { PortableText } from "@portabletext/react";
import styled from "styled-components";

const StyledBox = styled(Box)`
  p {
    padding: 0.5rem;
  }
  a {
    color: rgb(116, 114, 100);
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }
`;

const ContactPage = () => {
  const viewportSize = useContext(ResponsiveContext);
  const { siteData } = useContext(AppContext);
  if (!siteData) {
    return null;
  }
  return (
    <Box>
      <PageHeader label={siteData.contactPage.title} />

      <CenteredColumn>
        <Box
          direction={viewportSize === "small" ? "column" : "row"}
          gap="small"
          pad={"medium"}
          justify="center"
          align="center"
        >
          <Box
            direction="column"
            gap="small"
            align="evenly"
            pad={{ vertical: "medium" }}
          >
            <StyledBox>
              <PortableText value={siteData.contactPage.Content} />
            </StyledBox>
            <Box
              direction={viewportSize === "small" ? "column" : "row"}
              gap="small"
            >
              <Box
                width={"medium"}
                height={"medium"}
                alignSelf="center"
                round="small"
                background={{
                  image: "url(" + siteData.contactPage.smallImageLeftUrl + ")",
                  position: "center",
                }}
              ></Box>
              <Box
                width={"medium"}
                height={"medium"}
                alignSelf="center"
                round="small"
                background={{
                  image: "url(" + siteData.contactPage.smallImageRightUrl + ")",
                  position: "center",
                }}
              ></Box>
            </Box>
          </Box>
          <Box
            width={viewportSize === "small" ? "medium" : "large"}
            height={"large"}
            alignSelf="center"
            round="small"
            background={{
              image: "url(" + siteData.contactPage.largeImageUrl + ")",
              position: "center",
            }}
          ></Box>
        </Box>
      </CenteredColumn>

      <Box fill>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3398.9706232631347!2d-114.07887842955884!3d46.92526647513196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x535dcfc2344e5235%3A0xb611f63c321ef411!2s5767%20W%20Harrier%20%23201%2C%20Missoula%2C%20MT%2059808!5e1!3m2!1sen!2sus!4v1739822707237!5m2!1sen!2sus"
          width={"100%"}
          height={viewportSize === "small" ? "250" : "600"}
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Map"
        ></iframe>
      </Box>
    </Box>
  );
};
export default ContactPage;
